module.exports = __webpack_public_path__ + "img/hero_500X.be7c491d.jpg";